import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from '@reach/router';
import { Button, Tabs } from '@shopify/polaris';
import { useTenantContext } from 'src/components/TenantProvider';
import ProductGridContainer from 'src/components/ProductGridContainer';
import LoadingState from 'src/components/LoadingState';
import TopBar from 'src/components/TopBar';
import NextStepsComponent from 'src/components/NextSteps';
import SetUpComponent from 'src/components/SetUp';
import styleContants from 'src/styles/constants';

const NewCourseComponent = () => {
  const { session, tenant } = useTenantContext();
  const [tabIndex, setTabIndex] = useState(0);
  const [buttonLoadingState, setButtonLoadingState] = useState(false);
  const navigate = useNavigate();

  const handleTabChange = useCallback((selectedTabIndex) => {
    setTabIndex(selectedTabIndex);
  }, []);
  const tabs = [
    {
      id: 'courses',
      content: 'Courses',
      panelID: 'courses-content',
      TabComponent: ProductGridContainer,
    },
    {
      id: 'settings-links',
      content: 'Setup',
      panelID: 'setup-content',
      TabComponent: SetUpComponent,
    },
    {
      id: 'next-steps',
      content: 'Next steps',
      panelID: 'next-steps-content',
      TabComponent: NextStepsComponent,
    },
  ];
  const index = tabIndex <= tabs.length ? tabIndex : 0;
  const { TabComponent } = tabs[index];
  const tabContentClass =
    index === 0 ? 'tab__content tab__courses' : 'tab__content';

  useEffect(() => {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 500);
  }, [tenant]);

  return !session ? (
    <LoadingState />
  ) : (
    <>
      <TopBar />
      <div className="tabs__container">
        <Tabs selected={tabIndex} tabs={tabs} onSelect={handleTabChange}>
          {index === 0 && (
            <div className="tabs__button-container">
              <Button
                id="newcourse__button"
                loading={buttonLoadingState}
                primary
                onClick={() => {
                  navigate('/newcourse');
                  setButtonLoadingState(true);
                }}
              >
                Create course
              </Button>
            </div>
          )}
          <div className={tabContentClass}>
            <TabComponent />
          </div>
        </Tabs>
      </div>
      <style jsx>{`
        .tabs__container {
          position: fixed;
          width: 100%;
          top: 64px;
          left: 0;
        }
        .tabs__container :global(> div) {
          display: flex;
          flex-flow: column;
          height: 100vh;
          overflow: hidden;
        }

        .tabs__container :global(.Polaris-Tabs),
        .tabs__container :global(.Polaris-Tabs__TabMeasurer) {
          flex: 1 1 auto;
        }

        .tabs__container :global(.Polaris-Tabs__Panel) {
          flex: 1 1 100%;
          padding-bottom: 50px;
          overflow: scroll;
        }

        .tab__content {
          max-width: ${styleContants.containerWidth};
          margin: 0 auto;
          padding: 24px ${styleContants.spacing.two};
        }

        .tab__content.tab__courses {
          padding: 0 ${styleContants.spacing.two} ${styleContants.spacing.six};
        }

        .tabs__button-container {
          padding: ${styleContants.spacing.four} ${styleContants.spacing.two};
          width: 100%;
        }

        .tabs__button-container :global(button) {
          width: 100%;
        }

        @media (min-width: 48.0625em) {
          .tab__content,
          .tab__content.tab__courses {
            padding-top: 24px;
          }
          .tabs__button-container {
            padding: 0;
            position: absolute;
            right: 10px;
            top: 8px;
            width: auto;
            z-index: 3;
          }
          .tabs__button-container :global(button) {
            width: auto;
          }
        }
      `}</style>
    </>
  );
};

export default NewCourseComponent;
